module.exports = __webpack_public_path__ + "img/analytics.39a669fd.jpg";